/**
 * src/components/agent/SlashCommandMenu.jsx
 *
 * Phase 82-04 — Chat System Unification, composer menu.
 *
 * Renders the slash-command palette as a floating list above the composer.
 * Stateless — the parent drives results + cursor via useSlashCommands.
 */

import * as Icons from 'lucide-react';
import {
  menuPopoverStyle,
  menuListStyle,
  menuItemStyle,
  menuItemBodyStyle,
  menuItemLabelStyle,
  menuItemDescStyle,
  menuEmptyStyle,
} from './ChatComposerV2.styles';

function CommandIcon({ name, active }) {
  const Icon = (name && Icons[name]) || Icons.Command;
  return <Icon size={16} strokeWidth={2} color={active ? 'var(--accent)' : 'var(--tm)'} />;
}

export default function SlashCommandMenu({
  open,
  results,
  cursor,
  onHover,
  onSelect,
}) {
  if (!open) return null;
  return (
    <div
      style={menuPopoverStyle}
      role="listbox"
      aria-label="Slash commands"
      data-testid="slash-command-menu"
    >
      <div style={menuListStyle}>
        {results.length === 0 ? (
          <div style={menuEmptyStyle} data-testid="slash-command-empty">
            No matching commands
          </div>
        ) : (
          results.map((cmd, idx) => (
            <button
              key={cmd.slug}
              type="button"
              role="option"
              aria-selected={idx === cursor}
              onMouseEnter={() => onHover?.(idx)}
              onMouseDown={(e) => { e.preventDefault(); onSelect?.(cmd); }}
              style={menuItemStyle(idx === cursor)}
              data-testid={`slash-command-item-${cmd.slug}`}
            >
              <CommandIcon name={cmd.icon} active={idx === cursor} />
              <span style={menuItemBodyStyle}>
                <span style={menuItemLabelStyle}>/{cmd.slug}</span>
                <span style={menuItemDescStyle}>{cmd.description}</span>
              </span>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
